import BaseConfig from '@/config/base.js'

export function imgPath (url) {
  if (url) {
    return url.indexOf('http') >= 0 ? url : BaseConfig.imgHost + url
  }
  return url
}
